import { useDispatch } from 'react-redux'
import { Modal } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import { MdOutlineDeleteForever } from 'react-icons/md'
import { deleteNote } from '../../../redux/actions'
import './NoteModals.css'

const DeleteNoteModal = ({ open, onClose, noteId }) => {
  const dispatch = useDispatch()

  const handleDelete = () => {
    if (noteId) dispatch(deleteNote({ noteId }))
    onClose()
  }

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      className="nm-modal"
      width="min(380px, 95vw)"
      centered
      destroyOnClose
    >
      <div className="nm-header">
        <span className="nm-title">Delete Note</span>
        <button className="nm-close-btn" type="button" onClick={onClose}>
          <CloseOutlined />
        </button>
      </div>
      <div className="nm-divider" />

      <div className="nm-delete-body">
        <p className="nm-delete-text">Are you sure you want to delete this notes?</p>
        <button className="nm-delete-btn" type="button" onClick={handleDelete}>
          <MdOutlineDeleteForever /> Delete Note
        </button>
      </div>
    </Modal>
  )
}

export default DeleteNoteModal
